import { Link, useRouterState } from '@tanstack/react-router';

import { BrandMark } from '@/components/BrandMark';

import classes from './NotFound.module.css';

export function NotFound() {
    const pathname = useRouterState({ select: (state) => state.location.pathname });

    return (
        <div className={classes.page}>
            <div className={classes.card}>
                <BrandMark className={classes.crest} />
                <p className={classes.code}>404</p>
                <h1 className={classes.title}>Nothing here</h1>
                <p className={classes.description}>That page does not exist.</p>
                <code className={classes.path}>{pathname}</code>

                <div className={classes.actions}>
                    <Link to="/ops" className={classes.primary}>
                        Ops console →
                    </Link>
                    <Link to="/merchant" className={classes.secondary}>
                        Merchant portal
                    </Link>
                </div>

                <div className={classes.foot}>Black Arrow Logistics</div>
            </div>
        </div>
    );
}
